import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL, FRONTEND_URL } from "../../config/axios";
import { AddwithWhiteCircle, DeleteDustbin, DropdownArrow, QRcode, UpdatePencil } from "../AllSvg";
import { CustomImageModal, handleErrorToast } from "../CustomFunctions";
import { ToastContainer, toast } from "react-toastify";
import CivilmantraJobPostQR from "../../assets/images/CivilmantraJobPostQR.png";
import SaptagonJobPostQR from "../../assets/images/SaptagonJobPostQR.png";
import AimantraJobPostQR from "../../assets/images/AimantraJobPostQR.png";
import usePermission from "../../config/permissions";
import { useParams } from "react-router-dom";

// ! *************** Job Post Crud Models Start ***************

const ApplicationAdd = ({ designationname, departmentname, getJobpositionlist, getCompleteJobpostlist, status }) => {
  const [show, setShow] = useState(false);
  const [jobExists, setJobExists] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    // getCompleteJobpostlist();
    setShow(true)
  };


  const [formData, setFormData] = useState({
    department: "",
    position: "",
    experience: "",
    location: "",
    description: "",
    job_type: "",
    start_date: "",
    end_date: "",
    status: "",
    sub_company: sessionStorage.getItem('company_id')
  });


  useEffect(() => {
    const jobExistsForSpecificRow = Array.isArray(getCompleteJobpostlist) &&
      getCompleteJobpostlist.find(
        item =>
          item.department === formData.department &&
          item.position === formData.position
      );
    setJobExists(!!jobExistsForSpecificRow); // Set jobExists to true if jobExistsForSpecificRow is truthy
  }, [getCompleteJobpostlist, formData]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "department",
      "position",
      "experience",
      "location",
      "description",
      "job_type",
      "start_date",
      "end_date",
      "status",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };


  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); //loading logic

    if (validateForm()) {

      try {
        let res = await axios.post(`${BASE_URL}/jd/jobpost/`, formData,)

        if (res.status === 200) {
          setShow(false)
          await getJobpositionlist(status)
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err)
      } finally {
        setLoading(false); //loading logic
      }
    }
  };


  return (
    <>
      <button className="upload-svg" onClick={handleShow}>
        <AddwithWhiteCircle />{" "}Job Post
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Add new Job Post</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading  font-weight500 font-size-heading">Birthday </h6> */}

              <div className="flex-column form-group-selectt">
                <label htmlFor="department" className="form-labels font-weight500 font-size-subheading">
                  Department<span className="required">*</span>
                </label>
                <br />
                <select
                  id="department"
                  name="department"
                  value={formData.department}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.department ? "error" : inputState.department ? "success" : ""
                    }`}
                >
                  <option value="">Select a Department</option>
                  {departmentname?.sort((a, b) => a.title?.localeCompare(b.title, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                    <option value={i.id}>{i.title}-{i.sub_company_name}</option>
                  </>))
                  }
                </select>
                <DropdownArrow />
                <div>
                  {errors.department && (
                    <span className="error-message font-size-text ">{errors.department}</span>
                  )}
                </div>
              </div>



              <div className="flex-column form-group-selectt">
                <label htmlFor="position" className="form-labels font-weight500 font-size-subheading">
                  Position<span className="required">*</span>
                </label>
                <br />
                <select
                  id="position"
                  name="position"
                  value={formData.position}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.position ? "error" : inputState.position ? "success" : ""
                    }`}
                >
                  <option value="">Select a Position</option>
                  {designationname?.sort((a, b) => a.title.localeCompare(b.title, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                    <option value={i.id}>{i.title}-{i.sub_company_name}</option>
                  </>))
                  }
                </select>
                <DropdownArrow />
                <div>
                  {errors.position && (
                    <span className="error-message font-size-text ">{errors.position}</span>
                  )}
                </div>
              </div>

              <div className="flex-column">
                <label htmlFor="experience" className="form-labels font-weight500 font-size-subheading">
                  Experience<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="experience"
                  name="experience"
                  onChange={handleInputChange}
                  value={formData.experience}
                  className={`text-capitalize form-input ${errors.experience ? "error" : inputState.experience ? "success" : ""
                    }`}
                />
                {errors.experience && <span className="error-message font-size-text ">{errors.experience}</span>}
              </div>


              <div className="flex-column">
                <label htmlFor="location" className="form-labels font-weight500 font-size-subheading">
                  Location<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="location"
                  name="location"
                  onChange={handleInputChange}
                  value={formData.location}
                  className={`form-input ${errors.location ? "error" : inputState.location ? "success" : ""
                    }`}
                />
                {errors.location && <span className="error-message font-size-text ">{errors.location}</span>}
              </div>


              <div className="flex-column">
                <label htmlFor="start_date" className="form-labels font-weight500 font-size-subheading">
                  Start Date<span className="required">*</span>
                </label>
                <input
                  type="date"
                  id="start_date"
                  name="start_date"
                  onChange={handleInputChange}
                  value={formData.start_date}
                  className={`form-input ${errors.start_date ? "error" : inputState.start_date ? "success" : ""
                    }`}
                />
                {errors.start_date && <span className="error-message font-size-text ">{errors.start_date}</span>}
              </div>


              <div className="flex-column">
                <label htmlFor="end_date" className="form-labels font-weight500 font-size-subheading">
                  End Date<span className="required">*</span>
                </label>
                <input
                  type="date"
                  id="end_date"
                  name="end_date"
                  onChange={handleInputChange}
                  value={formData.end_date}
                  className={`form-input ${errors.end_date ? "error" : inputState.end_date ? "success" : ""
                    }`}
                />
                {errors.end_date && <span className="error-message font-size-text ">{errors.end_date}</span>}
              </div>

              <div className="flex-column form-group-selectt">
                <label htmlFor="job_type" className="form-labels font-weight500 font-size-subheading">
                  Job Type<span className="required">*</span>
                </label>
                <br />
                <select
                  id="job_type"
                  name="job_type"
                  value={formData.job_type}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.job_type ? "error" : inputState.job_type ? "success" : ""
                    }`}
                >
                  <option value="">Select Option</option>
                  <option value="full-time">Full Time</option>
                  <option value="part-time">Part Time</option>
                  <option value="intern">Intern</option>
                </select>
                <DropdownArrow />
                <div>
                  {errors.job_type && (
                    <span className="error-message font-size-text ">{errors.job_type}</span>
                  )}
                </div>
              </div>


              <div className="flex-column form-group-selectt">
                <label htmlFor="status" className="form-labels font-weight500 font-size-subheading">
                  Status<span className="required">*</span>
                </label>
                <br />
                <select
                  id="status"
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.status ? "error" : inputState.status ? "success" : ""
                    }`}
                >
                  <option value="">Select Option</option>
                  <option value="active">Active</option>
                  <option value="inactive">In Active</option>
                </select>
                <DropdownArrow />
                <div>
                  {errors.status && (
                    <span className="error-message font-size-text ">{errors.status}</span>
                  )}
                </div>
              </div>


              <div className="flex-column">
                <label htmlFor="description" className="form-labels font-weight500 font-size-subheading">
                  Description<span className="required">*</span>
                </label>
                <textarea
                  placeholder="Description"

                  type="text"
                  id="description"
                  name="description"
                  onChange={handleInputChange}
                  value={formData.description}
                  className={`form-input-textarea   font-weight400  font-size-subheading form-input-background ${errors.description ? "error" : inputState.description ? "success" : ""
                    }`}
                />
              </div>
              <div className="flex-column">
                {jobExists ?
                  <span className="required">Job post already exists for this department and designation.</span> :
                  ""}
              </div>

              <div className="button-models">
                <button className="model-button model-button-cancel font-weight500 " onClick={handleClose}>Cancel</button>
                {
                  jobExists ? "" :
                    <button
                      type="submit"
                      className="model-button  font-weight500 model-button-leave font-weight500 font-size-heading"
                      onClick={handleFormSubmit}
                      disabled={loading}
                    >
                      Add
                    </button>}
              </div>
            </div>
          </div>
        </Modal.Body>
        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </Modal>
    </>
  );
};

const Applicationupdate = ({ i, designationname, departmentname, getJobpositionlist, status }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const [formData, setFormData] = useState({
    department: i.department,
    position: i.position,
    experience: i.experience,
    location: i.location,
    description: i.description,
    job_type: i.job_type,
    start_date: i.start_date,
    end_date: i.end_date,
    status: i.status,
  });


  // useEffect(() => {
  //   setFormData(i);
  // }, [i]);


  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "department",
      "position",
      "experience",
      "location",
      "description",
      "job_type",
      "start_date",
      "end_date",
      "status",

    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };


  // ?  ************** Validation End **************  ! //
  const [loading, setLoading] = useState(false); //loading logic

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic

      try {
        let res = await axios.put(`${BASE_URL}/jd/jobpost/${i.id}/`, formData,)

        if (res.status === 200) {
          setShow(false)
          await getJobpositionlist(status)
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err)
      } finally {
        setLoading(false); //loading logic
      }
    }
  };


  return (
    <>
      <button className="model-edit-button-ml" title="Edit Job Posting" onClick={handleShow}>
        <UpdatePencil />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        {/* <Modal.Header closeButton>
          <Modal.Title>Request Leave</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading  font-weight500 font-size-heading">Birthday </h6> */}

              <div className="flex-column form-group-selectt">
                <label htmlFor="department" className="form-labels font-weight500 font-size-subheading">
                  Department<span className="required">*</span>
                </label>
                <br />
                <select
                  id="department"
                  name="department"
                  value={formData.department}
                  disabled
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.department ? "error" : inputState.department ? "success" : ""
                    }`}
                >
                  <option value="">Select a Department</option>
                  {departmentname?.sort((a, b) => a.title.localeCompare(b.title, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                    <option value={i.id}>{i.title}</option>
                  </>))
                  }
                </select>
                <DropdownArrow />
                <div>
                  {errors.department && (
                    <span className="error-message font-size-text ">{errors.department}</span>
                  )}
                </div>
              </div>

              <div className="flex-column form-group-selectt">
                <label htmlFor="position" className="form-labels font-weight500 font-size-subheading">
                  Position<span className="required">*</span>
                </label>
                <br />
                <select
                  id="position"
                  name="position"
                  disabled
                  value={formData.position}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.position ? "error" : inputState.position ? "success" : ""
                    }`}
                >
                  <option value="">Select a Position</option>
                  {designationname?.sort((a, b) => a.title.localeCompare(b.title, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                    <option value={i.id}>{i.title}</option>
                  </>))
                  }
                </select>
                <DropdownArrow />
                <div>
                  {errors.position && (
                    <span className="error-message font-size-text ">{errors.position}</span>
                  )}
                </div>
              </div>

              <div className="flex-column">
                <label htmlFor="experience" className="form-labels font-weight500 font-size-subheading">
                  Experience<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="experience"
                  name="experience"
                  onChange={handleInputChange}
                  value={formData.experience}
                  className={`text-capitalize form-input ${errors.experience ? "error" : inputState.experience ? "success" : ""
                    }`}
                />
                {errors.experience && <span className="error-message font-size-text ">{errors.experience}</span>}
              </div>


              <div className="flex-column">
                <label htmlFor="location" className="form-labels font-weight500 font-size-subheading">
                  Location<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="location"
                  name="location"
                  onChange={handleInputChange}
                  value={formData.location}
                  className={`form-input ${errors.location ? "error" : inputState.location ? "success" : ""
                    }`}
                />
                {errors.location && <span className="error-message font-size-text ">{errors.location}</span>}
              </div>


              <div className="flex-column">
                <label htmlFor="start_date" className="form-labels font-weight500 font-size-subheading">
                  Start Date<span className="required">*</span>
                </label>
                <input
                  type="date"
                  id="start_date"
                  name="start_date"
                  onChange={handleInputChange}
                  value={formData.start_date}
                  className={`form-input ${errors.start_date ? "error" : inputState.start_date ? "success" : ""
                    }`}
                />
                {errors.start_date && <span className="error-message font-size-text ">{errors.start_date}</span>}
              </div>


              <div className="flex-column">
                <label htmlFor="end_date" className="form-labels font-weight500 font-size-subheading">
                  End Date<span className="required">*</span>
                </label>
                <input
                  type="date"
                  id="end_date"
                  name="end_date"
                  onChange={handleInputChange}
                  value={formData.end_date}
                  className={`form-input ${errors.end_date ? "error" : inputState.end_date ? "success" : ""
                    }`}
                />
                {errors.end_date && <span className="error-message font-size-text ">{errors.end_date}</span>}
              </div>

              <div className="flex-column form-group-selectt">
                <label htmlFor="job_type" className="form-labels font-weight500 font-size-subheading">
                  Job Type<span className="required">*</span>
                </label>
                <br />
                <select
                  id="job_type"
                  name="job_type"
                  value={formData.job_type}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.job_type ? "error" : inputState.job_type ? "success" : ""
                    }`}
                >
                  <option value="">Select Option</option>
                  <option value="full-time">Full Time</option>
                  <option value="part-time">Part Time</option>
                  <option value="intern">Intern</option>
                </select>
                <DropdownArrow />
                <div>
                  {errors.job_type && (
                    <span className="error-message font-size-text ">{errors.job_type}</span>
                  )}
                </div>
              </div>


              <div className="flex-column form-group-selectt">
                <label htmlFor="status" className="form-labels font-weight500 font-size-subheading">
                  Status<span className="required">*</span>
                </label>
                <br />
                <select
                  id="status"
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.status ? "error" : inputState.status ? "success" : ""
                    }`}
                >
                  <option value="">Select Option</option>
                  <option value="active">Active</option>
                  <option value="inactive">In Active</option>
                </select>
                <DropdownArrow />
                <div>
                  {errors.status && (
                    <span className="error-message font-size-text ">{errors.status}</span>
                  )}
                </div>
              </div>


              <div className="flex-column">
                <label htmlFor="description" className="form-labels font-weight500 font-size-subheading">
                  Description<span className="required">*</span>
                </label>
                <textarea
                  placeholder="Description"
                  type="text"
                  id="description"
                  name="description"
                  onChange={handleInputChange}
                  value={formData.description}
                  className={`form-input-textarea   font-weight400  font-size-subheading form-input-background ${errors.description ? "error" : inputState.description ? "success" : ""
                    }`}
                />
              </div>
              <div className="button-models">
                <button className="model-button model-button-cancel font-weight500 " onClick={handleClose}>Cancel</button>
                <button
                  type="submit"
                  className="model-button  font-weight500 model-button-leave font-weight500 font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const ApplicationDelete = ({ i, getJobpositionlist }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    try {
      let res = await axios.delete(`${BASE_URL}/jd/jobpost/${i.id}/`);

      if (res.status === 200) {
        await getJobpositionlist("null");
        setShow(false);
      } else {
        console.error(res);
      }
    } catch (err) {
      handleErrorToast(err)
    }
  };

  return (
    <>
      <button className="model-delete-button" title="Delete Job Posting" onClick={handleShow}>
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title className="align-center">Delete Job Post </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div align-center">
            Are You Sure You Want to delete job post with
            <br />
            Department : {i.department_name}
            <br />
            Designation : {i.position_name}
            <br />
            <b>Note : This will also delete all job applicants for the same post including previously Accepted / Rejected or Pending Applicants</b>
            <div className="button-models">
              <button className="model-button model-button-cancel font-weight500 " onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button  font-weight500 model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

// ? *************** Job Post Crud Models End ***************


const QRShareButton = () => {
  const [showQR, setShowQR] = useState(false);
  const companyName = sessionStorage.getItem("company");
  const companyId = sessionStorage.getItem("company_id");

  const qrLink = `${FRONTEND_URL}/${companyId}/${companyName}/job-apply/`;

  const handleShow = () => setShowQR(true);
  const handleClose = () => setShowQR(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(qrLink);
      toast.success("Link copied!");
    } catch (err) {
      toast.error("Failed to copy");
    }
  };

  const qrMap = {
    Civilmantra: CivilmantraJobPostQR,
    Saptagon: SaptagonJobPostQR,
    Aimantra: AimantraJobPostQR,
  };

  const selectedQR = qrMap[companyName];

  const handleDownload = () => {
    if (!selectedQR) return;

    const link = document.createElement("a");
    link.href = selectedQR;
    link.download = `${companyName}JobPostQR.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <button className="upload-svg" onClick={handleShow}>
        <QRcode color="white" /> QR Share
      </button>

      <Modal show={showQR} onHide={handleClose} dialogClassName="request-leave width-30vw">
        <Modal.Header closeButton>
          <Modal.Title>Share Job Post</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div" style={{ textAlign: "center" }}>

              {/* QR IMAGE OR FALLBACK */}
              {selectedQR ? (
                <img
                  src={selectedQR}
                  alt="QR Code"
                  style={{
                    width: "200px",
                    height: "200px",
                    marginBottom: "20px",
                  }}
                />
              ) : (
                <div style={{ marginBottom: "20px", color: "gray" }}>
                  <QRcode size={40} />
                  <p>QR not available yet</p>
                </div>
              )}


              {/* LINK WITH COPY BUTTON */}
              <div className="flex-column">
                {/* <label className="form-labels font-weight500 font-size-subheading">
                  Link
                </label> */}

                <div className="">
                  <input
                    type="text"
                    value={qrLink}
                    readOnly
                    className="form-input"
                    style={{ paddingRight: "40px" }}
                  />


                  {/* <button
                    onClick={handleCopy}
                    style={{
                      cursor: "pointer",
                    }}
                    title="Click to Copy Form link"
                    className="Color-tag-active"
                  >
                    <span>
                      Get Link
                    </span>
                  </button> */}
                </div>
              </div>


              {/* DOWNLOAD BUTTON */}
              <div
                className="button-models"
                style={{ justifyContent: "center", marginTop: "20px" }}
              >
                <button
                  onClick={handleCopy}
                  style={{
                    cursor: "pointer",
                  }}
                  title="Click to Copy Form link"
                  className="model-button model-button-cancel font-weight500"
                >
                  Get Link
                </button>

                {
                  selectedQR && (<button
                    onClick={handleDownload}
                    className="model-button model-button-submit font-weight500"
                    title="Click to Copy Form link"
                  >
                    Download QR
                  </button>)
                }
              </div>

            </div>
          </div>
        </Modal.Body>

        <ToastContainer
          position="top-center"
          autoClose={1000}
          newestOnTop
          closeOnClick
          draggable
        />
      </Modal>
    </>
  );
};


const JobApplyLanding = () => {

  const [selectedJob, setSelectedJob] = useState("");
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [buffer2, setBuffering2] = useState(true); //buffering logic

  const [subCompanyData, setSubCompanyData] = useState({});
  const [jobpositionList, setJobPositionList] = useState([]);
  const [toggleStatus, setToggleStatus] = useState('active');
  let { company, company_id } = useParams()

  const getSubCompanyData = async () => {
    setBuffering1(true); // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany-by-id/${company_id}/`);
      setSubCompanyData(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering1(false);// End Buffering
    }
  };


  const getJobpositionlist = async () => {
    setBuffering2(true); // Start Buffering
    try {
      // const toggleCompany = SUB_COMPANIES.find(() => company.title = company)
      const res = await axios.get(`${BASE_URL}/jd/jobpostfilter/${toggleStatus}/${company_id}/`);
      setJobPositionList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering2(false);// End Buffering
    }
  };

  useEffect(() => {
    getSubCompanyData();
    getJobpositionlist();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedJob) return;

    const url = `${FRONTEND_URL}/personaldetails/${selectedJob}/`;

    window.open(url, "_blank"); // open in new tab
  };

  return (
    <div className="jd">

      {/* Heading */}
      <div className="jd-heading-outer">
        <h2 className="jd-heading-main font-weight600 font-size-heading">
          Apply for a Job
        </h2>
        {
          buffer1 ?
            <div className="spinner"></div>

            :
            subCompanyData?.company_logo ? (
              <CustomImageModal customStyle>
                <img
                  src={subCompanyData?.company_logo}
                  alt={subCompanyData?.title}
                  className="jdview-section-profilepic"
                />
              </CustomImageModal>
            )
              :
              <CustomImageModal customStyle>
                <img
                  className="jdview-section-profilepic"
                  src="https://g-eng.s3.ap-south-1.amazonaws.com/template-img/%60logo.png"
                  alt="profile-pic"
                />
              </CustomImageModal>}
        <div>
          <div className="jd-heading-bottom-bold"></div>
          <div className="jd-heading-bottom-light"></div>
        </div>
      </div>

      {/* Form */}
      <form className="register-form" onSubmit={handleSubmit}>

        <div className="form-flex-wrap">

          {/* Job Post Dropdown */}
          <div className="flex-column">
            <label className="form-labels font-weight500 font-size-subheading">
              Select Position <span className="required">*</span>
            </label>

            {buffer2 ?
              <div className="form-loader">
                <div className="bar-loader"></div>
              </div>
              : <select
                className="form-input"
                value={selectedJob}
                onChange={(e) => setSelectedJob(e.target.value)}
              >
                <option value="">Select Job Position</option>

                {jobpositionList.map((job) => (
                  <option key={job.id} value={job.id}>
                    {job.department_name} - {job.position_name}
                  </option>
                ))}

              </select>}

          </div>

        </div>

        {/* Button */}
        <div className="button-models">

          <button
            type="submit"
            className="model-button font-weight500 model-button-submit"
            disabled={!selectedJob}
          >
            Apply Now
          </button>

        </div>

      </form >
    </div >
  );
};


const CareerApplyLandingPage = () => {

  const [selectedJob, setSelectedJob] = useState("");
  const [buffer1, setBuffering1] = useState(true);
  const [buffer2, setBuffering2] = useState(true);

  const [subCompanyData, setSubCompanyData] = useState({});
  const [jobpositionList, setJobPositionList] = useState([]);
  const [toggleStatus] = useState('active');

  let { company, company_id } = useParams()

  const getSubCompanyData = async () => {
    setBuffering1(true);
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany-by-id/${company_id}/`);
      setSubCompanyData(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering1(false);
    }
  };

  const getJobpositionlist = async () => {
    setBuffering2(true);
    try {
      // const res = await axios.get(`${BASE_URL}/jd/jobpostfilter/${toggleStatus}/${company_id}/`);
      const res = await axios.get(`${BASE_URL}/jd/jobposts-lessdetails-bycompany-bystatus/${company_id}/${toggleStatus}/`);
      setJobPositionList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering2(false);
    }
  };

  useEffect(() => {
    getSubCompanyData();
    getJobpositionlist();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedJob) return;

    const url = `${FRONTEND_URL}/personaldetails/${selectedJob}/`;
    window.open(url, "_blank");
  };

  return (

    <div className="career-apply-landing-wrapper">

      <div className="career-apply-landing-card">

        {/* Logo */}
        <div className="career-apply-landing-logo">

          {buffer1 ?
            <div className="career-apply-landing-loader"></div>
            :
            <img
              src={
                subCompanyData?.company_logo
                  ? subCompanyData.company_logo
                  : "https://g-eng.s3.ap-south-1.amazonaws.com/template-img/%60logo.png"
              }
              alt="company-logo"
            />
          }

        </div>


        {/* Title */}
        <div className="career-apply-landing-title">
          <h1>Join Our Team</h1>
          <p>Select a job position and start your application</p>
        </div>


        {/* Form */}
        <form onSubmit={handleSubmit} className="career-apply-landing-form">

          <div className="career-apply-landing-field">

            <label>Select Job Position</label>

            {buffer2 ?
              <div className="form-loader-date">
                <div className="bar-loader"></div>
              </div>
              :
              <select
                value={selectedJob}
                onChange={(e) => setSelectedJob(e.target.value)}
              >
                <option value="">Select Job Position</option>

                {[...jobpositionList]?.sort((a, b) => {
                  const deptCompare = a.department_name.localeCompare(b.department_name, "en", {
                    ignorePunctuation: true,
                  });
                  if (deptCompare !== 0) return deptCompare;

                  return a.position_name.localeCompare(b.position_name, "en", {
                    ignorePunctuation: true,
                  });
                })?.map((job) => (
                  <option key={job.id} value={job.id}>
                    {job.department_name} - {job.position_name}
                  </option>
                ))}
              </select>
            }

          </div>


          {/* CTA Button */}
          <button
            type="submit"
            disabled={!selectedJob}
            className="career-apply-landing-btn"
          >
            Apply Now
          </button>

        </form>

      </div>

    </div>
  );
};

export { ApplicationAdd, Applicationupdate, ApplicationDelete, QRShareButton, JobApplyLanding, CareerApplyLandingPage };

